<template lang="pug">
.guest-shell
  .guest-shell__backdrop(aria-hidden="true")
  .guest-shell__wrapper
    .guest-shell__brand
      img.guest-shell__logo(:src="require('@/assets/logo.png')" alt="GigNet")
    slot(name="menu")
    .guest-shell__content
      slot
    footer.guest-shell__footer
      slot(name="footer")
        AppHelpText.guest-shell__notice(v-html="$t('login.notice')")
</template>

<script>
import AppHelpText from "@/components/AppHelpText";

export default {
  components: { AppHelpText },
};
</script>

<style lang="scss" scoped>
.guest-shell {
  @apply relative;
  @apply flex;
  @apply flex-col;
  @apply items-center;
  @apply justify-center;
  @apply py-4;
  // Not `min-h-full`: App.vue renders the legal notice right after every view,
  // so the shell leaves room for it instead of pushing it below the fold
  min-height: calc(100% - 4rem);

  &__backdrop {
    @apply fixed;
    @apply inset-0;
    @apply pointer-events-none;
    background-image: radial-gradient(
        60rem 32rem at 50% -12rem,
        rgba(28, 222, 232, 0.28),
        transparent 70%
      ),
      radial-gradient(
        44rem 30rem at 110% 105%,
        rgba(28, 140, 232, 0.22),
        transparent 65%
      ),
      linear-gradient(180deg, #f8fafc 0%, #eef2f7 100%);
  }

  &__wrapper {
    @apply relative;
    @apply w-full;
    @apply max-w-md;
    @apply flex;
    @apply flex-col;
    @apply items-center;
  }

  &__brand {
    @apply flex;
    @apply justify-center;
    @apply w-full;
    @apply mb-6;
  }

  &__logo {
    @apply h-14;
    @apply w-auto;
    @apply max-w-full;
    filter: drop-shadow(0 6px 12px rgba(11, 63, 106, 0.18));
    @screen sm {
      @apply h-16;
    }
  }

  &__content {
    @apply w-full;
  }

  &__footer {
    @apply w-full;
    @apply mt-4;
  }

  // wins over the `md:mt-6` AppHelpText applies to itself, so the footer keeps
  // its own rhythm regardless of stylesheet order
  &__footer &__notice {
    @apply mt-0;
  }
}
</style>
